import { CategorizedError } from "@modules/error/classes";
import { BusinessOperationErrorTypes } from "@shared/models/error.interface";

export class BusinessError<T = void> extends CategorizedError<T> {

  constructor(title: BusinessOperationErrorTypes, description: string, data?: T) {
    super(title as string, description, data);
  }

  handle<T>(forwardError: boolean = false): void {
    // HERE: create error log via Logging Service.
    const errorLogString = `[${this.title}] ${this.description}: ${JSON.stringify(this.data)}`;
    console.error(errorLogString);

    if (forwardError) throw new Error(this.title);
    
  }

}